const screens = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};

const colorCodes = {
    blue: '#0047FF',
    accentCyan: '#00A3FF',
    accentSky: '#BFE8FF',
    grayish: '#4F6291',
    black: '#000000',
    darkGray: '#4F4F4F',
    gray: '#828282',
    lightGray: '#E0E0E0',
    lightenGray: '#F8F8F8',
    white: '#FFFFFF',
    lightRed: '#EB5757',
    red: '#FA2E2E',
    lightGreen: '#6FCF97',
    green: '#27AE60',
    darkGreen: '#48A670',
    accentYellow: '#FCCA1E',
    accentViolet: '#7000FF',
    orange: '#FF6B00',
    lightOrange: '#FF9A3D'
};

const colors = {
    primary: colorCodes.blue,
    alert: colorCodes.red,
    ...colorCodes,
};

export const themeConfig = {
    screens,
    colors
};
